import React from 'react'
import { BrandSlide } from '../../../components/Widgets/Home/Slider/Slider.style'
import CustomSlider from 'components/Slider'
import useDeviceDetect from 'components/DeviceDetect'

const BrandsSlider = props => {
  const brands = props.brands
  const { isBrowser, isTablet } = useDeviceDetect()
  return (
    <div className={'brands-slider'}>
      <CustomSlider
        style={{ display: 'flex !important', justifyContent: 'space-between' }}
        settings={{
          dots: false,
          swipeToSlide: true,
          slidesToShow: isBrowser ? 8 : isTablet ? 6 : 4,
          autoplay: true,
          autoplaySpeed: 1500,
        }}
      >
        {brands.map((slide, i) => (
          <BrandSlide href={`brand/` + slide.slug} key={slide.name}>
            <div>
              <img alt={slide.name} src={slide.image} loading="eager" />
            </div>
          </BrandSlide>
        ))}
      </CustomSlider>
    </div>
  )
}

export default BrandsSlider
